/* 전체 지역 리스트 */
const url = '/monitor/areaStat';
export const getAllAreaStat = async (conn, callback, rejection) => {
  await conn
    .get(url + '/list')
    .then(response => {
      callback(response);
    })
    .catch(error => {
      rejection('getAllAreaStat Error', error);
    });
};

/* 주간 이벤트 발생 리스트*/
export const getWeekEvtList = async (conn, dongCode) => {
  const config = {
    params: {
      dongCode: dongCode,
    },
  };

  const response = await conn.get(url + '/event/week', config);

  return response;
};

/* 발생 이벤트 그리드 리스트 */
export const getOccurEvtList = async (conn, data) => {
  const { take, skip, dongCode } = data;

  const config = {
    params: {
      page: (take + skip) / take,
      size: take,
      dongCode: dongCode,
    },
  };

  const response = await conn.get(url + '/event/page', config);

  return response;
};
